import React, {FC} from 'react';
import {CitiesModalNew} from 'modules/modals/components/CitiesModalNew';

export const AppModals: FC = () => {
    return (
        <>
            <CitiesModalNew />
        </>
    );
};
